"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
class DataProvider {
    constructor(api, eventEmitter) {
        this.api = api;
        this.eventEmitter = eventEmitter;
        const frags = this.fragments;
        for (const key in frags) {
            this.api.fragmentRegistry.addFragment(key, frags[key]);
        }
    }
    get fragments() {
        return {};
    }
    getFragment(name, fields) {
        if (!fields)
            return this.api.fragmentRegistry.getFragment(name);
        if (typeof fields === "string")
            return fields;
        function buildFragmentFields(fields) {
            return Object.values(fields)
                .map(v => {
                if (typeof v === "string")
                    return v;
                const key = Object.keys(v).shift();
                return key + " {\n" + buildFragmentFields(v[key]) + "\n}";
            })
                .join("\n");
        }
        return `
      ... on ${name} {
        ${buildFragmentFields(fields)}
      }
    `;
    }
    getPageableFragment(name, fields) {
        return (`result {
              ` +
            this.getFragment(name, fields) +
            `
            }
            size
            page
            hasNextPage
            hasPrevPage
            totalPages
            totalRecords
            `);
    }
    request(gqlOperation, name, variables = {}, responseFragment = "") {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let vars = "";
            if (Object.keys(variables).length > 0) {
                vars = JSON.stringify(variables).replace(/([^\\])"([^"]+)":/g, "$1$2:");
                vars = "(" + vars.substring(1, vars.length - 1) + ")";
            }
            if (responseFragment.length > 0)
                responseFragment = "{" + responseFragment + "}";
            const q = `
      ${gqlOperation} {
        ${name} ${vars} ${responseFragment}
      }
    `;
            const method = gqlOperation === "query" ? "query" : "mutate";
            const resp = yield this.api[method]({
                [gqlOperation]: graphql_tag_1.default(q),
            });
            return resp.data[name];
        });
    }
    query(name, variables = {}, responseFragment = "") {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.request("query", name, variables, responseFragment);
        });
    }
    mutate(name, variables = {}, responseFragment = "") {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.request("mutation", name, variables, responseFragment);
        });
    }
    fetch(input, init, errorParser) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.api.fetch(input, init, errorParser);
        });
    }
    isReceiveErrors() {
        return this.api.getCallErrorHandler();
    }
    setReceiveErrors(v) {
        return this.api.setCallErrorHandler(v);
    }
}
exports.default = DataProvider;
//# sourceMappingURL=DataProvider.js.map